import { render, staticRenderFns } from "./veStuLiteraryActiveAdmin.vue?vue&type=template&id=8f4163e2&scoped=true"
import script from "./veStuLiteraryActiveAdmin.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryActiveAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4163e2",
  null
  
)

export default component.exports